import type { Messages } from '../de';

export default {
  title: 'Today',
  greeting: { morning: 'Good morning', day: 'Good afternoon', evening: 'Good evening' },
  week: 'Wk {n}',
  longDate: '{weekday}, {day} {month} {year}',
  accountAndMore: 'Account and more',
  loadError: 'Today can’t be loaded right now.',
  retry: 'Try again',
  loading: 'Loading …',
  heatmapLabel: 'Training heatmap',
  heatmapMobile: 'Last 20 weeks',
  heatmapDesktop: 'Training minutes, last 12 months',
  trainingMinutes: 'Training minutes',
  heatmapError: 'Heatmap unavailable: {error}',
  formEmpty: 'Fitness and form appear once there are activities with training load.',
  formError: 'Fitness/form unavailable: {error}',
  garminAttribution: 'Garmin data used with permission from Garmin',
  upload: {
    created: 'Activity created.',
    duplicate: 'Already there – no duplicate created.',
    failed: 'Upload failed: {error}',
    busy: 'Loading …',
    button: 'Upload FIT',
  },
  ampel: {
    label: 'Traffic light',
    rhrShort: 'RHR',
    level: { green: 'Green', yellow: 'Amber', red: 'Red' },
    advice: { green: 'train freely', yellow: 'go easy', red: 'rest or very easy' },
    asOf: 'Traffic light · as of {date}',
    tomorrow: 'Traffic light for tomorrow · from 6 pm',
    today: 'Traffic light for today',
    allGreen: 'All measured signals in the green.',
    notSynced: ' Not synced today yet.',
    missing: ' {missing} of 4 signals missing.',
    emptyTitle: 'No health data yet',
    emptyText: 'As soon as Garmin delivers sleep, HRV, Body Battery and resting HR, the traffic light shows here.',
    weekStreak: 'Weekly streak',
    streakWord: 'Streak',
    restart: 'start again',
  },
  streak: {
    label: 'Weekly streak',
    endsToday: 'Week ends today',
    endsOn: 'Week ends {date}',
    secured: 'this week secured',
    open: 'this week still open',
    none: 'no running streak',
    aria: 'Weekly streak {weeks} weeks, {status}',
    weeks: { one: '{count} week', other: '{count} weeks' },
    restartTitle: 'Start a new streak',
    securedBy: 'This week secured:',
    securedDetail: '{sport} {minutes} on {day}',
    openLine1: 'This week still open –',
    openLine2: 'one session by {date} keeps the streak.',
    startLine1: '1 activity this week',
    startLine2: 'starts a new streak.',
    since: 'since {date}',
    recentAria: 'Last {n} weeks: {active} with training',
    weekTitle: 'Week of {date}: {state}',
    withTraining: 'with training',
    withoutTraining: 'no training',
    lastWeeks: 'Last {n} weeks',
    withActivity: 'with activity',
    without: 'none',
  },
  thisWeek: {
    label: 'This week',
    title: 'This week · {time}',
    secured: 'Weekly streak secured',
    oneMore: 'Weekly streak: 1 more session',
    noTraining: 'no training yet',
    dayNoTraining: '{date} · no training',
    dayLetters: 'MTWTFSS',
  },
  year: {
    aria: 'Year {year}',
    soFar: '{year} so far',
    until: 'to {date}',
    empty: 'No activity this year yet.',
  },
  recent: {
    label: 'Recent activities',
    all: 'View all',
    empty: 'No activities yet. Sync Garmin or upload a FIT file.',
    race: 'Race',
    estimated: 'estimated without heart rate',
    fromHr: 'from heart rate',
    avgHr: 'avg {hr} bpm',
    source: { garmin: 'Garmin', strava: 'Strava export', fit: 'FIT upload' },
  },
  form: {
    range90: '90 days',
    range365: '12 months',
    fitness: 'Fitness (CTL)',
    fatigue: 'Fatigue (ATL)',
    form: 'Form (TSB)',
    ariaLabel: 'Fitness {ctl}, fatigue {atl}, form {tsb} ({word})',
    ariaRaces: '; races: {races}',
    raceOn: '{title} on {date}',
    noLoad: 'No training load in this period',
    title: 'Fitness, fatigue, form',
    subtitle: 'Load calculated here (hrTSS)',
    range: 'Period',
    formWord: 'Form ({word})',
    legendFitness: 'Fitness (CTL, 42 days)',
    legendFatigue: 'Fatigue (ATL, 7 days)',
    legendForm: 'Form (TSB)',
    legendRace: 'Race',
    axisDay: '{day}/{month}',
  },
  heatmap: {
    noTraining: 'no training',
    more: ' + {n} more',
    summary: '{days} training days · longest break {pause}',
    pauseDays: { one: '{count} day', other: '{count} days' },
    aria: 'Training minutes of the last {weeks} weeks: {days} training days, longest break {pause} days',
    legend: { l0: 'no training', l1: '1–29 min', l2: '30–59 min', l3: '1–2 h', l4: '2 h or more' },
    less: 'less',
    moreLegend: 'more',
  },
  comment: {
    label: 'Weekly comment',
    title: 'Weekly comment · Wk {week}',
    new: 'New',
    busy: 'Generating …',
    regenerate: 'Regenerate',
    generate: 'Generate now',
    meta: 'AI · {model} · Based on: {basis}',
    none: 'There’s no comment for last week yet – it’s written on Mondays by itself.',
    failed: 'Not generated: {error}',
    otherLang: 'Written in German',
  },
} satisfies Messages['heute'];
